import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Loader2, AlertCircle } from 'lucide-react';

// Dickies-Campus Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_sales-upgrade-5/artifacts/xcym6uev__DH_Icon.jpeg";

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg, #F4F2EE 0%, #FFFFFF 100%)' }}>
      <Card className="w-full max-w-md shadow-2xl border-0" style={{ background: '#FFFFFF' }}>
        {/* Signal-Rot Top-Bar wie in der Corporate-Landingpage */}
        <div style={{ height: '4px', background: '#D9775A', borderTopLeftRadius: 'inherit', borderTopRightRadius: 'inherit' }} />
        <CardHeader className="text-center pb-2 pt-8">
          <div className="flex justify-center mb-4">
            <img 
              src={LOGO_URL} 
              alt="Dickies-Campus Logo" 
              className="w-28 h-28 object-contain"
              style={{ filter: 'drop-shadow(0 4px 8px rgba(190, 53, 25, 0.15))' }}
            />
          </div>
          <div className="inline-flex items-center gap-2 justify-center mb-2">
            <span style={{ display: 'inline-block', width: '18px', height: '2px', background: '#D9775A' }} />
            <span style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#8E7B71' }}>
              Dickies-Campus CRM
            </span>
            <span style={{ display: 'inline-block', width: '18px', height: '2px', background: '#D9775A' }} />
          </div>
          <CardTitle className="text-3xl font-extrabold" style={{ color: '#1B1A18', letterSpacing: '-0.02em' }}>
            Willkommen
          </CardTitle>
          <p className="mt-1" style={{ color: '#3D3835' }}>Bildungszentrum für Pflege</p>
          <p className="text-xs mt-2" style={{ color: '#D9775A', fontWeight: 600 }}>Version 2.0 · 20.01.2026</p>
        </CardHeader>
        <CardContent className="pt-4 pb-6 px-8">
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3 flex items-center gap-2 text-red-700">
                <AlertCircle size={18} />
                <span className="text-sm">{error}</span>
              </div>
            )}
            
            <div className="space-y-2">
              <Label htmlFor="email" style={{ color: '#3D3835', fontWeight: 600 }}>E-Mail</Label>
              <Input
                id="email"
                type="email"
                placeholder="name@dickies-helden.de"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                style={{ background: '#ffffff', borderColor: '#D4C8BE' }}
                data-testid="login-email"
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="password" style={{ color: '#3D3835', fontWeight: 600 }}>Passwort</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ background: '#ffffff', borderColor: '#D4C8BE' }}
                data-testid="login-password"
              />
            </div>
            
            <Button 
              type="submit" 
              className="w-full text-white font-semibold rounded-full py-6 transition-all hover:shadow-lg"
              style={{ background: '#D9775A', letterSpacing: '0.03em' }}
              disabled={loading}
              onMouseOver={(e) => e.currentTarget.style.background = '#a12d16'}
              onMouseOut={(e) => e.currentTarget.style.background = '#D9775A'}
              data-testid="login-submit"
            >
              {loading ? (
                <>
                  <Loader2 size={18} className="mr-2 animate-spin" />
                  Anmelden…
                </>
              ) : (
                'Anmelden'
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;
